import { Component, OnInit } from '@angular/core';

// ionic
import { PopoverController } from '@ionic/angular';
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-add-note',
    templateUrl: './add-note.component.html',
    styleUrls: ['./add-note.component.scss'],
})
export class AddNoteComponent implements OnInit {

    slot;
    error: string;
    note: string;
    maxLength = 180;

    constructor(
        private popoverController: PopoverController,
        public translate: TranslateService
    ) { }

    ngOnInit() {}

    close() {
        this.popoverController.dismiss();
    }

    /**
     * process form, validate note
     */
    addNote(valid) {
        if (valid) {
            if (this.note.length > this.maxLength) {
                this.error = this.translate.instant('TIMESLOTS_NOTE_ERROR_TO_LONG', {'max': this.maxLength});
            } else {
                this.slot.note = this.note;
                this.popoverController.dismiss({
                    slot: this.slot
                });
            }
        }
    }

    /**
     * process form, validate note
     */
    deleteNote() {
        this.slot.note = '';
        this.popoverController.dismiss({
            slot: this.slot
        });
    }

}
